import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { ErrorService } from './error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private zone = inject(NgZone);
  private errorService = inject(ErrorService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    this.zone.run(() => {
      this.errorService.makeErrorMessage(error);
    });
  }
}
